import React from 'react';
import { Mail, Instagram, MapPin } from 'lucide-react';
import { WhatsAppIcon } from '../WhatsAppIcon';
import { siteConfig, STANDARD_PRICE } from '../../data/mock';

const serif = { fontFamily: 'Cormorant Garamond, serif', fontWeight: 300 };

const InfoRow = ({ icon: Icon, label, value, href, testId }) => {
  const Tag = href ? 'a' : 'div';
  const linkProps = href ? { href, target: href.startsWith('http') ? '_blank' : undefined, rel: 'noopener noreferrer' } : {};
  return (
    <Tag {...linkProps} className="flex items-center gap-4 text-[#b8b8b8] hover:text-[#c9a87c] transition-colors group" data-testid={testId}>
      <div className="w-12 h-12 flex items-center justify-center border border-white/20 group-hover:border-[#c9a87c] transition-colors">
        <Icon className="w-5 h-5" />
      </div>
      <div>
        <p className="text-xs text-[#888] uppercase tracking-wide mb-1">{label}</p>
        <p className="text-white">{value}</p>
      </div>
    </Tag>
  );
};

export const ContactInfo = () => (
  <div className="sticky top-32" data-testid="contact-info">
    <h2 className="text-2xl mb-8" style={serif}>Contact Information</h2>

    <div className="space-y-6 mb-12">
      <InfoRow icon={Mail} label="Email" value={siteConfig.email} href={`mailto:${siteConfig.email}`} testId="contact-email-link" />
      <InfoRow icon={Instagram} label="Instagram" value={siteConfig.instagram}
        href={`https://instagram.com/${siteConfig.instagram.replace('@', '')}`} testId="contact-instagram-link" />
      <InfoRow icon={WhatsAppIcon} label="WhatsApp" value={siteConfig.phone}
        href={`https://wa.me/${siteConfig.whatsapp}`} testId="contact-whatsapp-link" />
      <InfoRow icon={MapPin} label="Location" value={siteConfig.location} testId="contact-location" />
    </div>

    <div className="p-6 border-l-2 border-[#c9a87c]" style={{ background: 'rgba(201, 168, 124, 0.05)' }} data-testid="contact-pricing-note">
      <h3 className="text-lg mb-3" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Session Pricing</h3>
      <p className="text-[#b8b8b8] text-sm leading-relaxed">
        All sessions start at <span className="text-[#c9a87c] font-medium">{STANDARD_PRICE.toLocaleString()} AED</span>.
        Final pricing depends on location, duration, and specific requirements.
        Contact me for a personalized quote.
      </p>
    </div>
  </div>
);
